import { render } from "./Personales.vue?vue&type=template&id=1297fc9e&scoped=true"
import script from "./Personales.vue?vue&type=script&lang=js"
export * from "./Personales.vue?vue&type=script&lang=js"

import "./Personales.vue?vue&type=style&index=0&id=1297fc9e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1297fc9e"]])

export default __exports__